export const HELP_AND_SUPPORT = 'H&S';
export const MY_ACCOUNT_WEB = 'MY_ACCOUNT_WEB';
export const MY_ACCOUNT_APP_IOS = 'MY_ACCOUNT_APP_IOS';
export const MY_ACCOUNT_APP_ANDROID = 'MY_ACCOUNT_APP_ANDROID';
export const EINSTEIN_360 = 'EINSTEIN_360';
